import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import {
  DajOrganizacionuStrukturuOrganaResponse,
  KatalogInstitucijaClient,
  OrganizacionaJedinicaZaPrikazStrukture
} from 'app/api/iop-katalog-institucija-api-reference';
import { OJNode, OrganizacionaStrukturaOrganaTree } from 'app/models/features/sifarnici/organizaciona-struktura-organa-tree.model';

@Component({
  selector: 'app-organizaciona-struktura-organa',
  templateUrl: './organizaciona-struktura-organa.component.html',
  styleUrls: ['./organizaciona-struktura-organa.component.scss']
})
export class OrganizacionaStrukturaOrganaComponent implements OnInit, OnChanges {
  @Input() sifraOrgana: string;

  hijerarhijskaStrukturaOrganTip: OrganizacionaStrukturaOrganaTree[] = []
  checklistSelection = new SelectionModel<OJNode>(true)
  treeControl = new FlatTreeControl<OJNode>(
    node => node?.level, node => node.expandable
  );

  hasChild = (_: number, node: OJNode) => node.expandable;

  private _transformer = (node: OrganizacionaStrukturaOrganaTree, level: number) => {
    return {
      expandable: !!node.podredjeneOj && node.podredjeneOj.length > 0,
      name: node.nazivOj,
      level: level,
      parentId: node.nadredjenaOjId,
      id: node.idOj
    }
  }

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.podredjeneOj
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(
    private katalogInstituacijaService: KatalogInstitucijaClient,
    private router: Router
  ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.sifraOrgana) {
      await this.ucitajOrganizacionuStrukturu();
    }
  }

  ngOnInit() {
   
  }

  async ucitajOrganizacionuStrukturu() {
    let result: DajOrganizacionuStrukturuOrganaResponse;
    if (this.router.url.includes("moji-organi")) {
      result = await this.katalogInstituacijaService.dajOrganizacionuStrukturuOrgana(this.sifraOrgana).toPromise();
    } else {
      result = await this.katalogInstituacijaService.dajObjavljenuOrganizacionuStrukturuOrgana(this.sifraOrgana).toPromise();
    }
    
    this.dataSource.data = this.mapirajPodatke(result);
    // this.treeControl.expandAll();
  }

  mapirajPodatke(res: DajOrganizacionuStrukturuOrganaResponse) {
    if (!res) return [];
    return this.naparviHijerarhijskuStrukturu(null, res.organizacioneJedinice);
  }

  naparviHijerarhijskuStrukturu(id: number, sveOJ: OrganizacionaJedinicaZaPrikazStrukture[]) {
    let podredjeneOj = sveOJ.filter(x => x.nadredjenaOJId == id);
    let tree: OrganizacionaStrukturaOrganaTree[] = [];
    for (let oj of podredjeneOj) {
      let podredjenaOJ = new OrganizacionaStrukturaOrganaTree(
        oj.idOj,
        oj.nazivOJ,
        oj.nadredjenaOJId,
      );

      podredjenaOJ.podredjeneOj = this.naparviHijerarhijskuStrukturu(oj.idOj, sveOJ);
      tree.push(podredjenaOJ);
    }

    return tree;
  }
}
